import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  CustomButton,
  GeneralTableBox,
  PaginationTable,
  DialogBody,
  SearchBar,
  ActionIconButton,
} from '../../../common/components';

import PostAddIcon from '@mui/icons-material/PostAdd';

import GroupDialog from '../dialogs/GroupDialog';
import { usePaginatedFilter } from '../../../common/hooks/usePaginatedFilter';

const ITEMS_PER_PAGE = 5;

const filterGroups = (collection = [], term = '') => {
  if (!term?.trim()) return collection;
  const normalized = term.toLowerCase().trim();
  return collection.filter((group) => group.name?.toLowerCase().includes(normalized));
};

const GroupsTab = ({
  data,
  selectedItem,
  dialogOpen,
  editMode,
  handleAdd,
  handleEdit,
  handleDelete,
  handleClose,
  handleSave,
}) => {
  const {
    data: paginatedGroups,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  } = usePaginatedFilter({
    data,
    itemsPerPage: ITEMS_PER_PAGE,
    filterFn: filterGroups,
  });

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <CustomButton variant="contained" onClick={handleAdd}>
            <PostAddIcon sx={{ mr: 1 }} />
            Agregar
          </CustomButton>
          <SearchBar onSearch={handleSearch} />
        </Box>

        <GeneralTableBox>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Grupos</HeadTableCell>
                <HeadTableCell>N° Orden Desde</HeadTableCell>
                <HeadTableCell>N° Orden Hasta</HeadTableCell>
                <HeadTableCell>Fecha Creación</HeadTableCell>
                <HeadTableCell>Acciones</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedGroups.map((group, index) => (
                <TableRow key={group.id || index}>
                  <RowTableCell>{group.name}</RowTableCell>
                  <RowTableCell>{group.number_from}</RowTableCell>
                  <RowTableCell>{group.number_to}</RowTableCell>
                  <RowTableCell>{group.created_at}</RowTableCell>
                  <RowTableCell>
                    <ActionIconButton variant="edit" onClick={() => handleEdit(group)} />
                    <ActionIconButton variant="delete" onClick={() => handleDelete(group.uuid)} />
                  </RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {totalCount > rowsPerPage && (
            <PaginationTable
              totalPages={totalPages}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              totalCount={totalCount}
            />
          )}
        </GeneralTableBox>
      </Box>

      <GroupDialog
        open={dialogOpen}
        onClose={handleClose}
        onSave={handleSave}
        selectedItem={selectedItem}
        editMode={editMode}
      />
    </DialogBody>
  );
};

export default GroupsTab;
